import type { NextPage } from 'next';
import { ChangeEvent } from 'react';
import styles from './a-i-field.module.scss';
import { AIFieldType } from '@/types/heroBlock.types';

const VoiceInput: NextPage<AIFieldType> = ({
  className = '',
  property1 = 'Default',
  placeholder,
  label,
  value = '',

  onChange,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div className={[styles.root, className].join(' ')}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles['input-container']} data-property1={property1}>
        <input
          className={styles.input}
          placeholder={placeholder}
          type="text"
          disabled={property1 === 'Disabled'}
          value={value}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default VoiceInput;
